import { render, staticRenderFns } from "./app-bar.vue?vue&type=template&id=5ae043ca"
import script from "./app-bar.vue?vue&type=script&lang=js"
export * from "./app-bar.vue?vue&type=script&lang=js"
import style0 from "./app-bar.vue?vue&type=style&index=0&id=5ae043ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports